export default __webpack_public_path__ + "images/logo_pds.svg";